import React from 'react';
import styled from "styled-components";
import { useTheme } from '@mui/material/styles';
import { grey } from "@mui/material/colors";

const DottedTile = (props) => {
    const {
        title = '',
        padding = '0px',
    } = props;
    const theme = useTheme();

    const DottedCard = styled.div`
        border-radius: 5px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        box-sizing: border-box;
        &:hover .dotted-icon svg {
            color: ${theme.custom.dualTheme ? theme.palette.primary[600] : grey[500]}
        }
    `;

    return (
        <DottedCard
            style={{
                border: `2px dashed ${theme.palette.primary[200]}`,
                padding: padding,
            }}
        >
            <div className="dotted-icon">
                {props.children}
            </div>
            <p className="dotted-text">{title}</p>
        </DottedCard>
    );
}

export default DottedTile;